import {IService} from "@/model/Service/Service"

export interface IHasServicesEligible {
    getServicesEligible(): IService[]
    getServicesEligibleMap(): Map<string, IService>
    addServiceEligible(service: IService): void
    removeServiceEligible(service: IService): void
}

function hasServices<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasServicesEligible {
        private servicesEligible: IService[] = []
        private servicesEligibleMap: Map<string, IService> = new Map()

        constructor(...args: any[]) {
            super(...args);
        }

        public getServicesEligible(): IService[] {
            return this.servicesEligible
        }
        public getServicesEligibleMap(): Map<string, IService> {
            return this.servicesEligibleMap
        }
        public addServiceEligible(service: IService): void {
            if (this.servicesEligibleMap.has(service.getIdFull())) return
            this.servicesEligible.push(service)
            this.servicesEligibleMap.set(service.getIdFull(), service)
        }
        public removeServiceEligible(service: IService): void {
            if (!this.servicesEligibleMap.has(service.getIdFull())) return
            this.servicesEligible = this.servicesEligible.filter((existingService: IService) => existingService.getIdFull() !== service.getIdFull())
            this.servicesEligibleMap.delete(service.getIdFull())
        }
    };
}

export default hasServices